import type { ResumedResult } from '@sentinel/api-client';
import type { CreateApiKeyResult } from './use-api-keys';

/**
 * Recognize a resumed federated-step-up result as a freshly minted API key
 * (create OR rotate). Returns the `CreateApiKeyResult` to reveal, or `null` for
 * any other resumed action (revoke, list, failures) — those must NOT reveal a
 * one-time secret.
 */
export function asCreatedKey(result: ResumedResult): CreateApiKeyResult | null {
  if (!result.ok) return null;
  if (result.method.toUpperCase() !== 'POST') return null;

  let path: string;
  try {
    path = new URL(result.url).pathname;
  } catch {
    path = result.url.split(/[?#]/, 1)[0] ?? result.url;
  }

  const isCreate = /^\/auth\/api-keys$/.test(path);
  const isRotate = /^\/auth\/api-keys\/[^/]+\/rotate$/.test(path);
  if (!isCreate && !isRotate) return null;

  const body = result.body as Partial<CreateApiKeyResult> | null | undefined;
  if (body && typeof body.key === 'string' && typeof body.id === 'string') {
    return body as CreateApiKeyResult;
  }
  return null;
}
